export const SET_DASHBOARD_REQUEST = 'SET_DASHBOARD_REQUEST';
export const SET_DASHBOARD_SUCCESS = 'SET_DASHBOARD_SUCCESS';
export const SET_UPDATE_STAKEHOLDER_SUCCESS = 'SET_UPDATE_STAKEHOLDER_SUCCESS';
export const SET_DASHBOARD_FAILED = 'SET_DASHBOARD_FAILED';
export const CLEAN_DASHBOARD = 'CLEAN_DASHBOARD';
